import React from 'react';

import {useRoute, withKnownRoute} from '../../lib/routes';
import {ClassesPage} from './classes-page';
import {SubClassPage} from './sub-class-page';

/** Все адреса /classes/* обслуживает одна страница — какую показать, решает имя маршрута */
const ClassesRoute: React.FC = () => {
	const {routeName} = useRoute();
	const isSubClass = routeName === 'subClass' || routeName === 'subClassFeature';

	return isSubClass ? <SubClassPage /> : <ClassesPage />;
};

export default withKnownRoute(ClassesRoute);
